module.exports =  function(stops) {
    if (stops === 0) {
        return 'nonstop';
    } else if (stops === 1) {
        return '1 stop'
    } else {
        return stops + ' stops';
    }
}